module.exports = __webpack_public_path__ + "static/media/shoping-cart.cd3c4bde.mp4";